<profile-layout title="{{ 'Agent profile' | translate:'profile-info' }}">
  <ng-container class="profile-layout-body">
    <profile-in-agent-settings></profile-in-agent-settings>
    <profile-agent-contact-details></profile-agent-contact-details>
    <profile-address-book-box></profile-address-book-box>
  </ng-container>
</profile-layout>